import { jsx as _jsx } from "react/jsx-runtime";
import { Poll } from "./Poll";
import { Admin } from "./Admin";
import { Results } from "./Results";
import { CaseStudy } from "./CaseStudy";
export function App() {
    const path = window.location.pathname;
    if (path.startsWith("/admin"))
        return _jsx(Admin, {});
    if (path.startsWith("/results"))
        return _jsx(Results, {});
    if (path.startsWith("/case-study"))
        return _jsx(CaseStudy, {});
    return _jsx(Poll, {});
}
